import type { FieldDefinition } from '@facile-it/shark-morph/components/Form/fields/FieldDefinitions'
import { AbstractProvisioner } from '@facile-it/shark-morph/components/Form/provisioners/AbstractProvisioner'
import type { Observable } from 'rxjs'
import { of } from 'rxjs'
import provinceJson from '../../../data/provinces.json'
import type { Province } from '../../../models/province'

export namespace CitiesProvisioner {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface Options {}

    export type FieldOptions = FieldDefinition.Option<{ label: string; value: string }>[]
}

export class CitiesProvisioner extends AbstractProvisioner<CitiesProvisioner.Options> {
    public do(value: string): Observable<CitiesProvisioner.FieldOptions> {
        const StateCityRegExp = /^[\p{L}\p{M}\p{Zs}'.-]+$/u

        if (
            typeof value === 'undefined' ||
            (typeof value === 'string' && (value.length < 2 || !StateCityRegExp.test(value)))
        ) {
            return of([])
        }

        return of(
            provinceJson
                .filter((p: Province) => {
                    return (
                        p.name.toLowerCase().includes(value.toLowerCase()) ||
                        p.shortName.toLowerCase().includes(value.toLowerCase())
                    )
                })
                .map((p: Province) => ({
                    value: p.shortName,
                    label: p.name,
                }))
        )
    }
}
